import React, { Fragment } from 'react'
import { toTimestamp } from '@hlj/hlj-utils'
import indexStore from '../../store'
import { Badge } from 'hljd'
import { JUKE_PATH_A } from '@constant'

const { point } = indexStore

export default [
  {
    title: '活动名称',
    dataIndex: 'title',
    key: 'title',
    width: 300
  },
  {
    title: '报名时间',
    key: 'time',
    render: ({ publish_time, sign_up_end_time }) => (
      <div>
        <p>从 {publish_time.split(' ')[0]}</p>
        <p>至 {sign_up_end_time.split(' ')[0]}</p>
      </div>
    )
  },
  {
    title: '活动状态',
    key: 'active',
    width: 150,
    render: ({
      sign_up_end_time,
      pay_type,
      actual_bought_phones,
      create_point
    }) => (
      <div>
        {toTimestamp(sign_up_end_time) > toTimestamp() ? (
          <div>
            <p>报名中</p>
            {(pay_type == 0 || pay_type == 1) &&
              point == 0 && (
                <p style={{ color: '#ff8c47', fontSize: 12 }}>
                  活动点不足，新用户报名通知已暂停
                </p>
              )}
            {pay_type == 2 &&
              parseInt(actual_bought_phones) >= parseInt(create_point) &&
              point == 0 && (
                <p style={{ color: '#ff8c47', fontSize: 12 }}>
                  活动点不足，新用户报名通知已暂停
                </p>
              )}
            <p />
          </div>
        ) : (
          <div>报名完成</div>
        )}
      </div>
    )
  },
  {
    title: '报名人数',
    key: 'sign_up_finder_count',
    render: ({ sign_up_finder_count }) => <p>{sign_up_finder_count}人</p>
  },
  {
    title: '操作',
    key: 'operation',
    render: ({ sign_up_finder_new_count, merchant_activity_id }) => {
      return (
        <Fragment>
          <a href={`${JUKE_PATH_A}/newEnroll/${merchant_activity_id}`}>
            报名信息
          </a>
          <Badge
            count={sign_up_finder_new_count}
            style={{
              marginLeft: 10,
              verticalAlign: 'bottom',
              backgroundColor: '#ff705e'
            }}
          />
        </Fragment>
      )
    }
  }
]
